export default "__VITE_ASSET__CLxt1KZF__"